import React from 'react';
import PlayStoreLink from "./PlayStoreLink";
import {useNavigate} from "react-router-dom";

const CompletedPurchaseMessage = () => {

    const navigate = useNavigate();

    const handleClick = () => {
        navigate('../login');
    }

    return (
        <div className="">
            <div>Grazie del tuo acquisto!</div>
            <div>Scarica l'APP!</div>

            <div className="flex flex-row justify-center items-center w-full mt-8">
                <PlayStoreLink />
            </div>

            <div className="mt-4 cursor-pointer hover:underline inline-block font-medium" onClick={handleClick}>Accedi alla tua area riservata</div>
        </div>
    );
};

export default CompletedPurchaseMessage;
